module.exports = __webpack_public_path__ + "img/active-base1.52e35d5d.png";